import { useQuery } from '@tanstack/react-query';
import { fetchActiveProjects, ProjectsResponse } from '../adapters/activeProjectsAdapter';

export const useActiveProjects = () => {
  return useQuery<ProjectsResponse, Error>({
    queryKey: ['dashboard', 'active-projects'],
    queryFn: fetchActiveProjects,
    refetchOnWindowFocus: false,
  });
};
